import type { ImageLoader } from 'next/image';

const imageLoader: ImageLoader = ({ src }) => src;

export default imageLoader;
